export default function TemPermissao(
  userLogged: any,
  item: string,
  acao: string,
) {
  // Se o usuário for admin, retorna true
  if (userLogged?.data?.is_admin) {
    return true;
  }

  // Validação especial para overview - verifica se tem acesso a algum overview-*
  if (item === "overview") {
    const accessLevels = userLogged?.data?.accessLevels?.["niveis-de-acesso"];
    return (
      accessLevels &&
      Object.keys(accessLevels).some(
        (key) =>
          key.startsWith("overview-") &&
          accessLevels[key]?.permissoes?.includes(acao),
      )
    );
  }

  return !!userLogged?.data?.accessLevels?.["niveis-de-acesso"]?.[
    item
  ]?.permissoes?.includes(acao);
}

/**
 * Verifica se o usuário tem acesso à plataforma Ad Link.
 * Checa primeiramente via permissões (accessLevels), com fallback para a flag is_ad_link
 * enquanto o backend não migrar completamente para o sistema de permissões.
 */
export function hasAdLinkAccess(userLogged: any): boolean {
  const accessLevels = userLogged?.data?.accessLevels?.["niveis-de-acesso"];
  const hasAdLinkPermission =
    !!accessLevels &&
    Object.keys(accessLevels).some((key) => key.startsWith("ad-link"));
  // Fallback: flag legada enquanto backend não migrar
  return hasAdLinkPermission || userLogged?.data?.is_ad_link === true;
}

/**
 * Verifica se o usuário tem acesso ao sistema GoOn (plataforma principal).
 */
export function hasGoOnAccess(userLogged: any): boolean {
  return userLogged?.data?.is_user === true;
}

export function isRecruitingAndAdLinkOnly(userLogged: any): boolean {
  if (userLogged?.data?.is_admin) return false;
  if (!hasGoOnAccess(userLogged) || !hasAdLinkAccess(userLogged)) return false;

  const accessLevels = userLogged?.data?.accessLevels?.["niveis-de-acesso"];
  const modules = accessLevels ? Object.keys(accessLevels) : [];
  const allowedModules = ["vagas", "candidaturas"];

  return (
    modules.length > 0 &&
    modules.every((module) => allowedModules.includes(module))
  );
}

/**
 * Retorna true quando o usuário só tem acesso ao Ad Link,
 * sem nenhum acesso ao sistema GoOn principal.
 * Usado para redirecionar para /ad-link ao invés de /home.
 */
export function isAdLinkOnly(userLogged: any): boolean {
  return hasAdLinkAccess(userLogged) && !hasGoOnAccess(userLogged);
}
